import { useState } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import TodayShift from './components/TodayShift';

export default function Home() {
  const [openMap, setOpenMap] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero / WEB予約 */}
      <section id="reserve" className="pt-24 pb-16 bg-gradient-to-br from-pink-50 via-white to-purple-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-8">
            <img
              src="https://static.readdy.ai/image/7a6803503a084ffa064c71a8e4677aa3/cf44141841b9b36e73ca82220febca80.png"
              alt="JDスパ ロゴ"
              className="h-24 w-auto object-contain mx-auto mb-6"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
              JDスパ〜女子大生エステ〜
            </h1>
            <p className="text-gray-500 text-base mb-2">
              代々木上原・代々木公園・奥渋谷（宇田川町・神山町）
            </p>
            <p className="text-pink-400 text-sm">上質な癒し時間を、もっと身近に女子大生と♡</p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-pink-100 p-10 mb-6">
            <p className="text-gray-500 text-sm mb-6">当店本サイトへ移動します</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://r.caskan.jp/jdspa"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-10 py-5 bg-gradient-to-r from-pink-500 to-pink-400 text-white text-lg rounded-full font-bold hover:shadow-2xl transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-check-line mr-3 text-xl"></i>
                WEB予約はこちら
              </a>
              <a
                href="https://www.jd-spa.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-10 py-5 bg-white text-pink-500 border-2 border-pink-400 text-lg rounded-full font-bold hover:shadow-2xl hover:bg-pink-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-global-line mr-3 text-xl"></i>
                WEBサイトはこちら
              </a>
            </div>
            <p className="text-gray-400 text-xs mt-5">24時間いつでもご予約いただけます♡</p>
          </div>

          {/* ナビゲーションアンカー */}
          <div className="flex flex-wrap justify-center gap-3 mt-4 mb-6">
            {[
              { href: '#system', label: '料金システム' },
              { href: '#access', label: 'アクセス' },
              { href: '#notes', label: '注意事項' },
            ].map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-5 py-2 bg-white text-pink-500 border border-pink-300 rounded-full text-sm font-semibold hover:bg-pink-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* 本日の出勤 */}
          <TodayShift show={true} />
        </div>
      </section>

      {/* 料金システム */}
      <section id="system" className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-2">System</h2>
            <p className="text-pink-500 text-lg">料金システム</p>
          </div>

          {/* 入会手数料 */}
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-6 mb-8 flex items-center justify-between">
            <div className="flex items-center">
              <i className="ri-vip-crown-line text-pink-500 text-2xl mr-3"></i>
              <span className="text-lg font-semibold text-gray-800">初回登録料</span>
            </div>
            <span className="text-2xl font-bold text-pink-500">無料</span>
          </div>

          {/* コース料金 */}
          <h3 className="text-xl font-bold text-gray-800 mb-5 flex items-center">
            <i className="ri-time-line text-pink-500 mr-2"></i>コース料金
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {[
              { min: 40, price: '¥10,000', note: '手軽に癒されたい方に', popular: false, rank: '' },
              { min: 70, price: '¥14,000', note: 'じっくり癒されたい方に', popular: true, rank: '人気No.2' },
              { min: 90, price: '¥18,000', note: '一番人気のコース', popular: true, rank: '人気No.1' },
              { min: 110, price: '¥20,000', note: 'たっぷり癒しの時間', popular: false, rank: '' },
            ].map((course) => (
              <div
                key={course.min}
                className={`rounded-2xl p-6 text-center relative ${
                  course.popular
                    ? 'bg-gradient-to-br from-pink-100 to-purple-100 border-2 border-pink-300'
                    : 'bg-white border-2 border-pink-200'
                } hover:shadow-lg transition-shadow duration-300`}
              >
                {course.popular && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-pink-500 text-white text-xs px-3 py-1 rounded-full font-semibold whitespace-nowrap">
                    {course.rank}
                  </span>
                )}
                <div className="text-4xl font-bold text-pink-500 mb-1">{course.min}</div>
                <div className="text-gray-500 text-sm mb-3">分コース</div>
                <div className="text-2xl font-bold text-gray-800 mb-2">{course.price}</div>
                <p className="text-xs text-gray-500">{course.note}</p>
              </div>
            ))}
          </div>

          {/* 指名料 */}
          <h3 className="text-xl font-bold text-gray-800 mb-5 flex items-center">
            <i className="ri-star-line text-pink-500 mr-2"></i>指名料
          </h3>
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-5 flex items-center justify-between">
              <span className="text-gray-700 font-medium">指名・本指名</span>
              <span className="text-xl font-bold text-pink-500">¥1,000</span>
            </div>
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-5 flex items-center justify-between">
              <span className="text-gray-700 font-medium">フリー</span>
              <span className="text-xl font-bold text-pink-500">無料</span>
            </div>
          </div>

          {/* オプション */}
          <h3 className="text-xl font-bold text-gray-800 mb-5 flex items-center">
            <i className="ri-add-circle-line text-pink-500 mr-2"></i>オプション
          </h3>
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            {[
              { label: 'JDオリジナルしっとりホホバオイル', price: '無料' },
              { label: 'ハラ・ドキ秘密衣装', price: '無料' },
              { label: 'ジェ・ディープリンパ', price: '無料' },
              { label: 'テクニカルディープ', price: '無料' },
            ].map((opt) => (
              <div key={opt.label} className="bg-white border border-pink-200 rounded-xl p-5 flex items-center justify-between hover:shadow-md transition-shadow duration-200">
                <span className="text-gray-700">{opt.label}</span>
                <span className="text-lg font-bold text-pink-500">{opt.price}</span>
              </div>
            ))}
            <div className="md:col-start-1 md:col-end-3 flex justify-center">
              <div className="bg-white border border-pink-200 rounded-xl p-5 flex items-center justify-between hover:shadow-md transition-shadow duration-200 w-full md:w-1/2">
                <span className="text-gray-700">カンニング👀✨️</span>
                <span className="text-lg font-bold text-pink-500">¥5,000</span>
              </div>
            </div>
          </div>

          {/* 延長料金 */}
          <h3 className="text-xl font-bold text-gray-800 mb-5 flex items-center">
            <i className="ri-timer-line text-pink-500 mr-2"></i>延長料金
          </h3>
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-5 flex items-center justify-between">
              <span className="text-gray-700 font-medium">30分延長</span>
              <span className="text-xl font-bold text-pink-500">¥6,000</span>
            </div>
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-5 flex items-center justify-between">
              <span className="text-gray-700 font-medium">60分延長</span>
              <span className="text-xl font-bold text-pink-500">¥12,000</span>
            </div>
          </div>

          {/* 出張エリア */}
          <h3 className="text-xl font-bold text-gray-800 mb-5 flex items-center">
            <i className="ri-map-pin-line text-pink-500 mr-2"></i>出張エリア・交通費
          </h3>
          <div className="bg-white border-2 border-pink-200 rounded-2xl p-6 mb-8">
            <div className="space-y-3">
              <div className="flex items-center justify-between py-3">
                <span className="text-gray-700">都内主要エリア</span>
                <span className="font-bold text-pink-500">コース料金+￥5,000~</span>
              </div>
            </div>
          </div>

          {/* お支払い */}
          <h3 className="text-xl font-bold text-gray-800 mb-5 flex items-center">
            <i className="ri-bank-card-line text-pink-500 mr-2"></i>お支払い方法
          </h3>
          <div className="grid grid-cols-3 gap-4">
            {[
              { icon: 'ri-money-dollar-circle-line', label: '現金' },
              { icon: 'ri-bank-card-2-line', label: 'クレジットカード' },
              { icon: 'ri-smartphone-line', label: '電子決済' },
            ].map((pay) => (
              <div key={pay.label} className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-5 text-center">
                <i className={`${pay.icon} text-3xl text-pink-500 mb-2`}></i>
                <p className="text-gray-700 text-sm font-semibold">{pay.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* アクセス */}
      <section id="access" className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Access</h2>
            <p className="text-pink-500 text-lg">アクセス</p>
          </div>

          {/* エリア大見出し */}
          <div className="text-center mb-10">
            <p className="text-2xl md:text-3xl font-bold text-gray-800">
              代々木上原・代々木公園・奥渋谷（宇田川町・神山町）
            </p>
          </div>

          {/* エリアカード */}
          <div className="grid md:grid-cols-3 gap-6 mb-10">
            {[
              {
                id: 'yoyogiuehara',
                name: '代々木上原',
                mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.748!2d139.6808!3d35.6617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f4b3b3b3b3b3%3A0x0!2z5Luj3Yq55LiK5Y6f6aeF!5e0!3m2!1sja!2sjp!4v1700000001',
              },
              {
                id: 'yoyogikouen',
                name: '代々木公園',
                mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.9!2d139.6942!3d35.6636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f34b2e3b3b3b%3A0x0!2z5Luj3Yq55YWs5ZyS6aeF!5e0!3m2!1sja!2sjp!4v1700000002',
              },
              {
                id: 'okushibuya',
                name: '奥渋谷',
                mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.5!2d139.6980!3d35.6580!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f33b2e3b3b3b%3A0x0!2z5riL6LC35Y6f!5e0!3m2!1sja!2sjp!4v1700000003',
              },
            ].map((area) => (
              <div
                key={area.id}
                className="rounded-2xl border border-pink-100 shadow-sm overflow-hidden bg-white"
              >
                <div className="bg-gradient-to-r from-pink-50 to-rose-50 px-5 py-3 border-b border-pink-100">
                  <h3 className="text-lg font-bold text-gray-800 text-center">{area.name}</h3>
                </div>
                <div className="w-full h-48">
                  <iframe
                    src={area.mapSrc}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title={`${area.name}エリアマップ`}
                    className="block"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* 補足 */}
          <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-6 mb-10 flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-checkbox-circle-fill text-pink-400 text-base"></i>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              各エリアともに徒歩圏内の好立地からご案内いただけます。
            </p>
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href="https://r.caskan.jp/jdspa"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-10 py-4 bg-gradient-to-r from-pink-500 to-pink-400 text-white text-base rounded-full font-semibold hover:shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-6 h-6 flex items-center justify-center mr-2">
                <i className="ri-calendar-check-line text-xl"></i>
              </div>
              WEB予約はこちら
            </a>
          </div>
        </div>
      </section>

      {/* 注意事項 */}
      <section id="notes" className="py-20 bg-gradient-to-br from-pink-50 via-purple-50 to-pink-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Notes</h2>
            <p className="text-pink-500 text-lg">注意事項</p>
            <p className="text-gray-500 text-sm mt-2">安心してご利用いただくために、以下の内容をご確認ください♡</p>
          </div>

          <div className="space-y-6">
            {/* 施術について */}
            <div className="bg-white rounded-2xl p-7 border border-pink-100 shadow-sm">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-heart-pulse-line text-pink-500 mr-2 text-xl"></i>施術について
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                当店のサービスは、リラクゼーションを目的としたマッサージです。医療行為ではございませんので、あらかじめご了承ください。
              </p>
            </div>

            {/* ご利用を控えていただくケース */}
            <div className="bg-white rounded-2xl p-7 border border-pink-100 shadow-sm">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-error-warning-line text-pink-500 mr-2 text-xl"></i>ご利用を控えていただくケース
              </h3>
              <div className="grid md:grid-cols-2 gap-2">
                {['泥酔状態の方', '持病をお持ちの方（事前にご相談ください）', '発熱や感染症の症状がある方', '手術直後の方', '炎症や怪我のある方'].map((item) => (
                  <div key={item} className="flex items-start space-x-2">
                    <i className="ri-close-circle-fill text-pink-400 text-base flex-shrink-0 mt-0.5"></i>
                    <p className="text-gray-600 text-sm">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* 禁止事項 */}
            <div className="bg-white rounded-2xl p-7 border border-pink-100 shadow-sm">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-forbid-line text-pink-500 mr-2 text-xl"></i>禁止事項
              </h3>
              <div className="grid md:grid-cols-2 gap-3">
                {[
                  { title: 'セラピストへの接触強要', desc: '不適切な接触や要求は固くお断りいたします。' },
                  { title: '盗撮・録音等', desc: '無断での撮影、録音、録画は一切禁止です。' },
                  { title: '性的サービスの要求', desc: '性的なサービスの要求は固くお断りいたします。' },
                  { title: 'スカウト・引き抜き行為', desc: 'SNSを含むスカウト・引き抜き行為は禁止です。' },
                ].map((item) => (
                  <div key={item.title} className="bg-pink-50 rounded-xl p-4">
                    <p className="font-semibold text-gray-800 text-sm mb-1">{item.title}</p>
                    <p className="text-gray-500 text-xs">{item.desc}</p>
                  </div>
                ))}
              </div>
              <p className="text-xs text-pink-600 font-semibold mt-4">
                ※上記に該当する行為が確認された場合、即座にサービスを中止し、今後のご利用をお断りさせていただきます。
              </p>
            </div>

            {/* キャンセル */}
            <div className="bg-white rounded-2xl p-7 border border-pink-100 shadow-sm">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-calendar-close-line text-pink-500 mr-2 text-xl"></i>キャンセル・遅刻について
              </h3>
              <div className="space-y-2">
                {[
                  'キャンセルの際は、必ず事前にご連絡をお願いいたします。',
                  '無断キャンセルや直前のキャンセルが続く場合、今後のご予約をお断りする場合がございます。',
                  '遅刻された場合、施術時間が短縮となる場合がございます。料金は変わりませんのでご了承ください。',
                ].map((text) => (
                  <div key={text} className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-base flex-shrink-0 mt-0.5"></i>
                    <p className="text-gray-600 text-sm">{text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* 反社会的勢力 */}
            <div className="bg-white rounded-2xl p-7 border border-pink-100 shadow-sm">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-shield-check-line text-pink-500 mr-2 text-xl"></i>反社会的勢力の排除
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                当店は反社会的勢力との一切の関係を遮断し、取引を行いません。不当な要求に対しては毅然とした対応を行います。
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
